import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LoadingState } from '@personal-area/global/state';

import { ABTestConfig } from '../../models/ab-test';
import { ProfileVariant } from '../../models/profile-variant.dto';
import { ABTestState } from '../reducers/ab-test';

const getABTestStore = createFeatureSelector<ABTestState>('abTest');

export const getABTests = createSelector(
  getABTestStore,
  (state: ABTestState): ProfileVariant[] => state.tests,
);

export const getABTestsLoadingState = createSelector(
  getABTestStore,
  (state: ABTestState): LoadingState => state.loadingState,
);

export const getABTestsConfig = createSelector(
  getABTestStore,
  (state: ABTestState): ABTestConfig => state.config,
);
